<div class="profile-container pt-1" [ngClass]="rootClassName">
  <div class="profile-profile">
    <div class="profile-content-container pt-md-3">
      @if (!isWeb) {
        @if (isOpenSlide) {
          <pop-ui-navigationbar class="profile-navigationbar" [(state)]="subNavigationState"></pop-ui-navigationbar>
        } @else {
          <pop-ui-navigationbar class="profile-navigationbar" [(state)]="mainNavigationState"></pop-ui-navigationbar>
        }
      }
      <div class="profile-content-row">
        <div class="profile-content">
          <ng-template [ngTemplateOutlet]="_editProfileTemplate"></ng-template>
          <hr class="divider"/>
          <div class="profile-table">
            @for (entry of entries; track $index) {
              <div class="profile-listrow">
                <ng-template [ngTemplateOutlet]="_entryTemplate" [ngTemplateOutletContext]="{entry}"></ng-template>
              </div>
            }
          </div>
          <hr class="divider"/>
        </div>
        @if (isWeb) {
          <div class="profile-content right">
            <ng-template [ngTemplateOutlet]="_contentTemplate"></ng-template>
          </div>
        }
      </div>
    </div>
  </div>
</div>

@if (!isWeb && isOpenSlide) {
  <div class="profile-sliding-right-container">
    <ng-template [ngTemplateOutlet]="_contentTemplate"></ng-template>
  </div>
}

<!-- Templates -->

<ng-template #_confirmLogout>
  <div class="modal-header border-0">
    <h4 class="modal-title pull-left headingboldsmall">Are you sure ?</h4>
    <button type="button" class="btn btn-xs btn-close close pull-right" aria-label="Close" (click)="cancel()">
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>Signing out without creating an account will erase your study history and progress tracking. Create an account now to safeguard your data and enhance your learning experience !</p>
    <div class="text-center mt-2">
      <button type="button" class="btn btn-primary" (click)="create()">Create Account</button>
      <button type="button" class="btn btn-default" (click)="signout()">I don't care. Sign out</button>
    </div>
  </div>
</ng-template>

<ng-template #_contentTemplate>
  <div class="profile-sliding-right-content scrollable" [ngClass]="content==='settings'?'pt-1 pt-md-3':'pt-0'">
    @switch (content) {
      @case ('unsubscribe') { <pop-ui-legal id="legal" [(legal)]="content" rootClassName="scrollable p-0"></pop-ui-legal> }
      @case ('tacos') { <pop-ui-legal id="legal" [(legal)]="content" rootClassName="scrollable p-0"></pop-ui-legal> }
      @case ('privacy') { <pop-ui-legal id="legal" [(legal)]="content" rootClassName="scrollable p-0"></pop-ui-legal> }
      @case ('cookie') { <pop-ui-legal id="legal" [(legal)]="content" rootClassName="scrollable p-0"></pop-ui-legal> }
      @case ('edit') { <pop-ui-profile-edit (close)="onClose('edit')"></pop-ui-profile-edit> }
      @case ('join') { <pop-ui-join-classroom (close)="onClose('join')"></pop-ui-join-classroom> }
      @case ('settings') { <nx-superprep-settings (close)="onClose('settings')"></nx-superprep-settings> }
      @case ('help') { <pop-ui-profile-help (close)="onClose('help')"></pop-ui-profile-help> }
      @case ('report') { <pop-ui-profile-report (close)="onClose('report')"></pop-ui-profile-report> }
      @case ('suggestion') { <pop-ui-profile-suggest (close)="onClose('suggestion')"></pop-ui-profile-suggest> }
    }
</div>
</ng-template>

<ng-template #_editProfileTemplate>
  <div class="profile-listrow padded">
    <div class="profile-row" (click)="onAction('edit')">
      <div class="profile-col2">
        <div class="profile-row01">
          <div class="profile-avatar">
            <pop-ui-avatar></pop-ui-avatar>
          </div>
        </div>
      </div>
      <div class="profile-col3">
        <div class="profile-row02">
          <div class="profile-row03">
            <span class="profile-text headingboldmedium">
              <span>{{profileName}}</span>
            </span>
          </div>
        </div>
        <div class="profile-row04">
          <div class="profile-row05">
            <span class="profile-text02 labelregularsmall">
              <span>{{email}}</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #_entryTemplate let-entry="entry">
  <div class="profile-listrow py-3" (click)="onAction(entry.name)">
    <div class="profile-row06">
      <span class="profile-text04" [ngClass]="entry.active ? 'labelboldxsmall' : 'labelmediumxsmall'">
        <span>{{entry.title|titlecase}}</span>
      </span>
      @if (!isWeb) {
        <div class="profile-action">
          <img loading="lazy" alt="iconarrowright" src="/assets/icons/iconarrowright.svg" class="profile-iconarrowright"/>
        </div>
      }
    </div>
  </div>
</ng-template>
